export default "__VITE_ASSET__DKsUSUve__"